import { Component, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { LiftStatsComponent } from '../lift-stats/lift-stats.component';

@Component({
	selector: 'app-lift-stats-r5',
	styleUrls: ['./lift-stats-r5.component.css'],
	templateUrl: './lift-stats-r5.component.html'
})
export class LiftStatsR5Component extends LiftStatsComponent implements OnInit {
	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.requestData();
	}
}
